import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { CHANGE_ROUTE_POINT_STATUS } from '../../../../graphql/Catalog/Trucks/Routes/routesPoints'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import ModalContent from '../../../Global/ModalContent'
import RoutesPlanning from './Components/RoutesPlanning'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import {
  CHANGE_STATUS_TO_ROUTE,
  COMPLETE_ROUTE_BY_ROUTE_ID,
  GET_ALL_ROUTES,
} from '../../../../graphql/Catalog/Trucks/Routes/routesTrucks'
import RoutesPoints from './Components/RoutesPoints'
import RoutesTrucksNew from './RoutesTrucksNew'
import moment from 'moment'
import DetailsRoute from './Components/DetailsRoute'
import ProgressBarRoutes from './Components/Helpers/ProgressBarRoutes'
import {
  arrayStatus,
  fnObjNameStatus,
  objectStatusRoutes,
} from '../../../../const/constStatuses_routes'
import TimeLines from '../../../Global/TimeLines/TimeLines'
import ModalInterruptRoute from './Components/Helpers/ModalInterruptRoute'
import usePermissions from '../../../../CustomHooks/usePermissions'
import { AuthContext } from '../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../const/constRoles'
import { GET_ALL_TRUCKS } from '../../../../graphql/Catalog/Trucks/trucks'
import { GET_ALL_STATUS_BY_TYPE } from '../../../../graphql/Catalog/Status/status'
import { GET_ALL_PROVIDERS } from '../../../../graphql/Catalog/Providers/providers'

const RoutesTrucks = () => {
  const { user } = useContext(AuthContext)
  const objNameStatusRoutes = fnObjNameStatus()
  const isProvider = user && user.role === objNameRoles.provedor_pipas
  const { hideLoading, showLoading } = useLoading()
  const refModal = useRef(null)
  const refModalAux = useRef(null)

  const [providerSelected, setProviderSelected] = useState(null)
  const [dataTable, setDataTable] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      provider_id: null,
      truck_id: null,
      status_id: null,
    },
  })

  const [routeId, setRouteId] = useState(null)
  const [routeComplete, setRouteComplete] = useState(false)
  const [editRoute, setEditRoute] = useState(false)

  //SATETE GLOBAL
  const [routeIsOnRoute, setRouteIsOnRoute] = useState(false)
  const [isLastPoint, setIsLastPoint] = useState(false)

  //STATES FOR FIRST MODAL
  const [addNewRoute, setAddNewRoute] = useState(false)
  const [detailsRoute, setDetailsRoute] = useState(false)
  const [editRoutes, setEditRoutes] = useState(false)
  const [closeModal, setCloseModal] = useState(false)
  const [modalContent, setModalContent] = useState({
    title: null,
    content: null,
    size: 'extra',
    modalId: null,
  })

  //STATES FOR SECOND MODAL
  const [detailsRoutePoint, setDetailsRoutePoint] = useState(null)
  const [addRequestToRoute, setAddRequestToRoute] = useState(false)
  const [fetchsData, setFetchsData] = useState(false)
  const [waterRequestId, setWaterRequestId] = useState(null)
  const [closeModalAux, setCloseModalAux] = useState(false)
  const [modalContentAux, setModalContentAux] = useState({
    title: null,
    content: null,
    size: 'extra',
    modalId: null,
  })
  const [options, setOptions] = useState({
    truck_id: [],
    status_id: [],
    provider_id: [],
  })

  const { loading, error, data, refetch } = useQuery(GET_ALL_ROUTES, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
      filters: {
        provider_id: pagePagination.filters.provider_id,
        truck_id: pagePagination.filters.truck_id,
        status_id: pagePagination.filters.status_id,
      },
    },
    fetchPolicy: 'no-cache',
  })

  const {
    loading: loadingTrucks,
    error: errorTrucks,
    data: dataTrucks,
  } = useQuery(GET_ALL_TRUCKS, {
    variables: {
      filters: {
        provider_id: providerSelected,
      },
    },
    fetchPolicy: 'no-cache',
  })

  const {
    loading: loadingProviders,
    error: errorProviders,
    data: dataProviders,
  } = useQuery(GET_ALL_PROVIDERS, {
    variables: {},
    fetchPolicy: 'no-cache',
    skip: isProvider,
  })

  const [changeStatus] = useMutation(CHANGE_STATUS_TO_ROUTE)
  const [completeRoute] = useMutation(COMPLETE_ROUTE_BY_ROUTE_ID)
  const [GetStatusByType] = useMutation(GET_ALL_STATUS_BY_TYPE, {
    fetchPolicy: 'no-cache',
    variables: {
      type: 'routes',
    },
  })
  const {
    create: permissionCreate,
    read: permissionRead,
    edit: permissionEdit,
    erase: permissionErase,
  } = usePermissions(user)

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error
      if (!data) throw new Error('No se encontraron datos')

      const { getAllRoutes } = data

      // if(!getAllRoutePoints) throw new Error('No se encontraron datos')

      const infoRoutes = getAllRoutes.rows.map((route) => {
        let completed = 0

        route.RouteToRoutePoints.map((point) => {
          if (
            point.RoutePointsToWaterTruckRequest.StatusOfWaterTruckRequest
              .name === 'Completado'
          ) {
            completed++
          }
        })
        const getNameStatus = arrayStatus.find(
          (item) => item.id === route?.RoutesToStatus?.id
        )

        return {
          id: route?.id,
          folio: route?.invoice,
          ...(!isProvider && {
            proveedor: route?.RouteToProvider?.card_name || 'N/A',
          }),
          conductor: `${route?.RouteToUser?.name} ${route?.RouteToUser?.first_name}`,
          camion: route?.RouteToTrucks?.plate_number,
          Capacidad: route?.volume + 'm³',
          fecha: moment(route?.scheduled_date).format('DD/MM/YYYY'),
          estatus: <ProgressBarRoutes status={route?.RoutesToStatus} />,
          Solicitudes: (
            <ProgressBarRoutes
              totalPoints={route?.RouteToRoutePoints?.length}
              completedPoints={completed || 0}
              routeInfo={route}
              handleEditRoutesPoints={handleEditRoutesPoints}
            />
          ),
          // rutas: (
          //   <>
          //     {(getNameStatus.name === 'nuevo' ||
          //       getNameStatus.name === 'interrumpido') && (
          //       <button
          //         className="btn btn-sm btn-accept ml-2"
          //         onClick={() =>
          //           handleChangeStatus(
          //             route.id,
          //             getNameStatus.id,
          //             getNameStatus.name
          //           )
          //         }
          //       >
          //         <i className="fas fa-play"></i>
          //       </button>
          //     )}
          //     {getNameStatus.name === 'en_ruta' && (
          //       <button
          //         className="btn btn-sm btn-accept ml-2"
          //         onClick={() =>
          //           handleInterruptRoute(route.id, getNameStatus.id)
          //         }
          //       >
          //         <i className="fas fa-pause"></i>
          //       </button>
          //     )}
          //     {getNameStatus.name === 'interrumpido' && (
          //       <button
          //         className="btn btn-sm btn-accept ml-2"
          //         onClick={() => handleFinishRoute(route.id)}
          //         style={{
          //           marginLeft: '5px',
          //           width: '30px',
          //         }}
          //       >
          //         <i className="fas fa-check"></i>
          //       </button>
          //     )}
          //   </>
          // ),

          accions_custom: (
            <div className="my-3 d-flex flex-column acciones">
              <div className="d-flex" style={{ gap: '5px' }}>
                <>
                  {(getNameStatus.name === 'nuevo' ||
                    getNameStatus.name === 'interrumpido') && (
                    <button
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      onClick={() =>
                        handleChangeStatus(
                          route?.id,
                          getNameStatus.id,
                          getNameStatus.name
                        )
                      }
                      title={
                        getNameStatus.name === 'nuevo'
                          ? 'Iniciar ruta'
                          : 'Reiniciar ruta'
                      }
                    >
                      <i className="fas fa-play"></i>
                    </button>
                  )}
                  {getNameStatus.name === 'en_ruta' && (
                    <button
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      onClick={() =>
                        handleInterruptRoute(route.id, getNameStatus.id)
                      }
                      title="Interrumpir ruta"
                    >
                      <i className="fas fa-pause"></i>
                    </button>
                  )}
                  {getNameStatus.name === 'interrumpido' && (
                    <button
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      onClick={() => handleFinishRoute(route.id)}
                      title="Finalizar ruta"
                    >
                      <i className="fas fa-check"></i>
                    </button>
                  )}
                </>
                {permissionRead && (
                  <button
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={() => handleDetailsRoute(route)}
                    title="Ver detalles de la ruta"
                  >
                    <i className="fas fa-eye mr-1" />
                  </button>
                )}

                {permissionEdit && (
                  <button
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={() => handleEditRoute(route.id, route)}
                    title="Editar ruta"
                  >
                    <i className="fas fa-edit mr-1" />
                  </button>
                )}

                <button
                  className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                  onClick={() => handleTimeline(route.id)}
                  title="Historial de la ruta"
                >
                  <i className="fas fa-clock mr-1" />
                </button>

                {/* {foundStatusCurrentInStatusRole(item.status_id) && (
                  <button
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={(e) =>
                      handleOpenModal(e, item.id, item, item?.folio)
                    }
                    title="Procesar"
                  >
                    <i className="fas fa-cogs me-2"></i>
                  </button>
                )}

                <button
                  onClick={(e) => handleGeneratePdf(item.id, item?.folio)}
                  className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                  title="Imprimir reporte"
                >
                  <i className="fas fa-print" />
                </button> */}
              </div>
            </div>
          ),
          route__omit: route,
        }
      })

      setDataTable(infoRoutes)
      setTotalCount(getAllRoutes.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  //OPEN MODAL
  useEffect(() => {
    if (modalContent.modalId) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
    }
  }, [modalContent])

  //CLOSE MODAL
  useEffect(() => {
    if (closeModal) {
      refModal.current.click()
      setModalContent({
        title: null,
        content: null,
        modalId: null,
        size: 'extra',
      })
      setCloseModal(false)
      setRouteId(null)
      setEditRoutes(false)
    }
  }, [closeModal])

  useEffect(() => {
    if (routeId) {
      // refModal.current.click()
      setFetchsData((prev) => ({
        ...prev,
        refetchMain: refetch,
      }))
      setTimeout(() => {
        setModalContent({
          title: `${editRoute ? 'Editar ruta' : 'Detalles de la ruta'} - 
          ${routeComplete.invoice} - 
          ${routeComplete.volume}m³`,
          content: (
            <>
              {editRoutes || detailsRoute ? (
                <RoutesPoints
                  detailsRoute={detailsRoute}
                  routeComplete={routeComplete}
                  routeId={routeId}
                  refModal={refModal}
                  setCloseModal={setCloseModal}
                  setWaterRequestId={setWaterRequestId}
                  setFetchsData={setFetchsData}
                  setAddRequestToRoute={setAddRequestToRoute}
                  setDetailsRoutePoint={setDetailsRoutePoint}
                  routeIsOnRoute={routeIsOnRoute}
                  setIsLastPoint={setIsLastPoint}
                  refetchPrincipal={refetch}
                />
              ) : (
                <>
                  <RoutesPlanning
                    routeId={routeId}
                    refModal={refModal}
                    refetchMain={refetch}
                    setCloseModal={setCloseModal}
                    closeModal={closeModal}
                    routeIsOnRoute={routeIsOnRoute}
                  />
                </>
              )}
            </>
          ),
          size: 'extra',
          modalId: 'modal-routes-trucks',
        })
      }, 400)
    }
  }, [routeId])

  useEffect(() => {
    if (addNewRoute) {
      setTimeout(() => {
        setModalContent({
          title: 'Crear Ruta',
          content: (
            <>
              <RoutesPlanning
                refModal={refModal}
                refetchMain={refetch}
                setCloseModal={setCloseModal}
                closeModal={closeModal}
              />
            </>
          ),
          // content: (
          //   <>
          //     <RoutesTrucksNew
          //       // routeTruckId={requestTruckId}
          //       // setRequestTruckId={setRequestTruckId}
          //       routesPoints={routesPoints}
          //       setRoutesPoints={setRoutesPoints}
          //     />
          //   </>
          // ),
          size: 'extra',
          modalId: 'modal-routes-trucks',
        })
      }, 400)

      setAddNewRoute(false)
    }
  }, [addNewRoute])

  useEffect(() => {
    if (waterRequestId) {
      const statusOnRoute = !!waterRequestId.route_point__omit.loaded_at
      setModalContentAux({
        title: `Editar Petición ${waterRequestId.folio}`,
        content: (
          <>
            <RoutesTrucksNew
              routeId={routeId}
              waterRequestId={waterRequestId}
              setCloseModalAux={setCloseModalAux}
              refModalAux={refModalAux}
              fetchsData={fetchsData}
              routeIsOnRoute={routeIsOnRoute}
              disabledFieldsRoutePoint={statusOnRoute}
              isLastPoint={isLastPoint}
            />
          </>
        ),
        size: 'extra',
        modalId: 'modal-routes-points',
      })
    }
  }, [waterRequestId, isLastPoint])

  useEffect(() => {
    if (addRequestToRoute) {
      setModalContentAux({
        title: `Agregar peticiones a la Ruta - 
          ${routeComplete.invoice} - 
          ${routeComplete.volume}m3`,
        content: (
          <>
            <RoutesTrucksNew
              routeId={routeId}
              setCloseModalAux={setCloseModalAux}
              refModalAux={refModalAux}
              fetchsData={fetchsData}
              routeComplete={routeComplete}
            />
          </>
        ),
        size: 'extra',
        modalId: 'modal-routes-points',
      })
    }
  }, [addRequestToRoute])

  useEffect(() => {
    if (detailsRoutePoint) {
      setModalContentAux({
        title: `Detalles de la Ruta - ${detailsRoutePoint.folio}`,
        content: (
          <>
            <DetailsRoute routePoint={detailsRoutePoint} />
          </>
        ),
        size: 'extra',
        modalId: 'modal-routes-points',
      })
    }
  }, [detailsRoutePoint])

  useEffect(() => {
    if (modalContentAux.modalId) {
      document.getElementById(`spanModal${modalContentAux.modalId}`).click()
    }
  }, [modalContentAux])

  useEffect(() => {
    if (closeModalAux) {
      refModalAux.current.click()
      setModalContentAux({
        title: null,
        content: null,
        modalId: null,
        size: 'extra',
      })
      setCloseModalAux(false)
      setWaterRequestId(null)
      setAddRequestToRoute(false)
    }
  }, [closeModalAux])

  useEffect(() => {
    try {
      if (loadingTrucks) return
      if (errorTrucks) throw errorTrucks
      if (!dataTrucks) throw new Error('No se encontraron datos')

      const { getAllTrucks } = dataTrucks
      //CUBICS METRICS - m#
      const trucks = getAllTrucks.rows.map((truck) => ({
        value: truck.id,
        label: `${truck.plate_number} - ${truck.capacity} m³`,
      }))

      setOptions((prev) => ({
        ...prev,
        truck_id: trucks,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingTrucks, errorTrucks, dataTrucks])

  useEffect(() => {
    try {
      const handleGetStatus = async () => {
        const { data } = await GetStatusByType({})

        const status = data.getAllStatusByType.map((status) => ({
          value: status.id,
          label: status.name,
        }))

        setOptions((prev) => ({
          ...prev,
          status_id: status,
        }))
      }

      // if (!isProvider) {
      handleGetStatus()
      // }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [GetStatusByType])

  useEffect(() => {
    try {
      if (isProvider) return
      if (loadingProviders) return
      if (errorProviders) throw errorProviders
      if (!dataProviders) throw new Error('No se encontraron datos')
      const { getAllProviders } = dataProviders

      const providers = getAllProviders.rows.map((provider) => ({
        value: provider.id,
        label: `${provider.card_name} - ${provider.rfc}`,
      }))
      setOptions((prev) => ({
        ...prev,
        provider_id: providers,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingProviders, errorProviders, dataProviders])

  const handleAddNewRoute = () => {}

  const handleEditRoutesPoints = (id, status, row) => {
    const statusOnRoute =
      status === 'En Ruta' ? 1 : status === 'Completado' ? 2 : false
    setRouteId(id)
    setEditRoutes(true)
    setRouteIsOnRoute(statusOnRoute)
    setRouteComplete(row)
  }

  const handleEditRoute = (id, row) => {
    const getStatus = objectStatusRoutes[row.status_id]
    const statusOnRoute =
      getStatus.key === 'in_route'
        ? 1
        : getStatus.key === 'completed_route'
        ? 2
        : getStatus.key === 'interrupted_route'
        ? 3
        : false

    setRouteIsOnRoute(statusOnRoute)
    setRouteComplete(row)
    setRouteId(id)
    setEditRoute(true)
  }

  const handleDetailsRoute = (row) => {
    setRouteId(row)
    setRouteComplete(row)
    // setRouteId(row.route__omit)
    // setRouteComplete(row.route__omit)
    setDetailsRoute(true)
  }

  const handleChangeStatus = async (id, statusId, nameStatus) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        icon: 'info',
        // message: '¿Desea iniciar la ruta?',
        message: `${
          nameStatus === 'nuevo'
            ? '¿Desea iniciar la ruta?'
            : nameStatus === 'en_ruta'
            ? '¿Desea pausar la ruta?'
            : '¿Desea reiniciar la ruta?'
        }`,
      })

      if (!response.isConfirmed) return

      showLoading()

      const { data } = await changeStatus({
        variables: {
          changeStatusToRouteId: +id,
          statusId: statusId,
        },
      })

      if (data.changeStatusToRoute) {
        await refetch()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Ruta iniciada correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleInterruptRoute = async (id, statusId) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        icon: 'info',
        message: '¿Desea interrumpir la ruta?',
        // message: `${
        //   nameStatus === 'nuevo'
        //     ? '¿Desea iniciar la ruta?'
        //     : nameStatus === 'en_ruta'
        //     ? '¿Desea pausar la ruta?'
        //     : '¿Desea reiniciar la ruta?'
        // }`,
      })

      if (!response.isConfirmed) return

      setModalContent({
        title: 'Interrumpir Ruta',
        size: 'large',
        modalId: 'modal-interrupt-route',
        content: (
          <ModalInterruptRoute
            routeId={id}
            statusId={statusId}
            refetch={refetch}
            setCloseModal={setCloseModal}
          />
        ),
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleFinishRoute = async (id) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        icon: 'info',
        message: '¿Desea finalizar la ruta?',
      })

      if (!response.isConfirmed) return

      showLoading()

      const { data: dataComplete } = await completeRoute({
        variables: {
          completeRouteId: id,
        },
        fetchPolicy: 'no-cache',
      })

      if (dataComplete.completeRoute) {
        await refetch()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Ruta finalizada correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleTimeline = (id) => {
    setModalContent({
      title: 'Historial de la Ruta',
      size: 'large',
      modalId: 'modal-timelines',
      content: (
        <TimeLines document_id={id} category="routes" withCard={false} />
      ),
    })
  }

  const handleFilterChange = (e, id) => {
    try {
      switch (id) {
        case 'provider_id':
          setProviderSelected(e ? e.value : null)
          setPagePagination((prev) => ({
            ...prev,
            filters: {
              ...prev.filters,
              provider_id: e ? e.value : null,
              truck_id: null,
            },
          }))
          break
        default:
          setPagePagination((prev) => ({
            ...prev,
            filters: {
              ...prev.filters,
              [id]: e ? e.value : null,
            },
          }))
          break
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  return (
    <>
      <ContentHeader
        title="Rutas de Pipas"
        windowTitle="Rutas de Pipas"
        breadcrumb=""
      />

      <LayoutTable
        hideId
        hideAddNew
        data={dataTable}
        totalCount={totalCount}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        title="Rutas de Pipas"
        extraHeaderButtonFunction={() => setAddNewRoute(true)}
        extraHeaderButtonFunctionText="Crear Ruta"
        hideActions
        // actionBtnEdit={handleEditRoute}
        // actionBtnDetails={handleDetailsRoute}
        hideBtnDelete
        // handleButtonSecond={handleTimeline}
        // handleButtonSecondTitle="Historial"
        filterChoosen={[
          {
            condition: isProvider,
            id: 'provider_id',
            name: 'Proveedor',
            placeholder: 'Selecciona un proveedor',
            options: options.provider_id,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'provider_id'),
          },
          {
            id: 'truck_id',
            name: 'Camión',
            placeholder: 'Selecciona un camión',
            options: options.truck_id,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'truck_id'),
            value: pagePagination.filters.truck_id,
            defaultValue: pagePagination.filters.truck_id,
          },
          {
            id: 'status_id',
            name: 'Estatus',
            placeholder: 'Selecciona un estatus',
            options: options.status_id,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'status_id'),
          },
        ]}
        cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
        cols_search_div="col-12"
        cols_filters={
          isProvider
            ? 'col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3'
            : 'col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3'
        }
        cols_filters_div="col-12"
      />

      <span
        id={`spanModal${modalContent.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalContent.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModal}
      ></span>

      <ModalContent
        idModal={modalContent.modalId}
        title={modalContent.title}
        size={modalContent.size}
        onClose={() => {
          setModalContent({
            title: null,
            content: null,
            modalId: null,
            size: 'extra',
          })
          setRouteId(null)
          setDetailsRoute(false)
          setEditRoutes(false)
          setRouteComplete(false)
          setRouteIsOnRoute(false)
          setEditRoute(false)
        }}
        content={modalContent.content}
      />

      <span
        id={`spanModal${modalContentAux.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalContentAux.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalAux}
      ></span>

      <ModalContent
        idModal={modalContentAux.modalId}
        title={modalContentAux.title}
        size={modalContent.size}
        onClose={() => {
          setModalContentAux({
            title: null,
            content: null,
            modalId: null,
            size: 'extra',
          })
          setWaterRequestId(null)
          setAddRequestToRoute(false)
          setDetailsRoutePoint(false)
        }}
        content={modalContentAux.content}
      />
    </>
  )
}

export default RoutesTrucks
